import { render, staticRenderFns } from "./NevronImageAndVideoField.vue?vue&type=template&id=0f934787&"
import script from "./NevronImageAndVideoField.vue?vue&type=script&lang=ts&"
export * from "./NevronImageAndVideoField.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports